var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button-pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timeline-preview-01",
    transform: "translate(-1084.000000, -120.000000)",
    fill: "#D8248A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1064.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-pause",
    transform: "translate(20.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,30 C23.2842712,30 30,23.2842712 30,15 C30,6.71572875 23.2842712,0 15,0 C6.71572875,0 0,6.71572875 0,15 C0.00895605952,23.2805587 6.71944131,29.9910439 15,30 Z M9.08,20.0285227 L9.08,10.5739773 C9.08,9.59492703 9.91946609,8.80125 10.955,8.80125 L11.545,8.80125 C12.5805339,8.80125 13.42,9.59492703 13.42,10.5739773 L13.42,20.0285227 C13.42,21.007573 12.5805339,21.80125 11.545,21.80125 L10.955,21.80125 C9.91946609,21.80125 9.08,21.007573 9.08,20.0285227 L9.08,20.0285227 Z M16.51,10.5739773 C16.51,9.59492703 17.3494661,8.80125 18.385,8.80125 L19.045,8.80125 C20.0805339,8.80125 20.92,9.59492703 20.92,10.5739773 L20.92,20.0285227 C20.92,21.007573 20.0805339,21.80125 19.045,21.80125 L18.385,21.80125 C17.3494661,21.80125 16.51,21.007573 16.51,20.0285227 L16.51,10.5739773 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPause);
export default __webpack_public_path__ + "static/media/button-pause.4b481d07c8715e78fbeb1eb744fbdbdd.svg";
export { ForwardRef as ReactComponent };